/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface GetAppointmentBaseResponse
 */
export interface GetAppointmentBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetAppointmentBaseResponse
     */
    appointmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentBaseResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentBaseResponse
     */
    description: string | null;
}

/**
 * Check if a given object implements the GetAppointmentBaseResponse interface.
 */
export function instanceOfGetAppointmentBaseResponse(value: object): value is GetAppointmentBaseResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function GetAppointmentBaseResponseFromJSON(json: any): GetAppointmentBaseResponse {
    return GetAppointmentBaseResponseFromJSONTyped(json, false);
}

export function GetAppointmentBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['appointmentId']),
        'name': json['name'],
        'description': json['description'],
    };
}

export function GetAppointmentBaseResponseToJSON(json: any): GetAppointmentBaseResponse {
    return GetAppointmentBaseResponseToJSONTyped(json, false);
}

export function GetAppointmentBaseResponseToJSONTyped(value?: GetAppointmentBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['appointmentId']),
        'name': value['name'],
        'description': value['description'],
    };
}

